import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  checkbox: {
    transform: "scale(1.5)",
    marginRight: theme.spacing(1),
  },
}));
